import { makeApiMutation } from "@web-monorepo/fetchers";
import { useCallback } from "react";
import { useSessionFetcher } from "src/pods/auth/useSessionFetcher";

const useDismissNuxMutation = makeApiMutation({
  name: "dismissNux",
  path: "/api/userConfig/metadata/{metaDataName}",
  method: "put",
  onSuccess: () => {
    useSessionFetcher.invalidateQueries();
  },
});

function useDismissNux(metaDataName: string) {
  const { mutate } = useDismissNuxMutation();

  return useCallback(() => {
    mutate({
      path: { metaDataName },
      body: { value: true },
    });
  }, [mutate, metaDataName]);
}

export function useDismissWelcomeNux() {
  return useDismissNux("toolkitWelcomeDismissed");
}

export function useDismissParentToolkitNux() {
  return useDismissNux("parentToolkitNuxDismissed");
}
